import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Grid, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import RestartAltIcon from '@mui/icons-material/RestartAlt';


const SearchForm = ({ datos, onSearch, toggleModal }) => {
    const clientes = datos.clientes || [];
    const estados = datos.estados || [];
    const tecnicos = datos.tecnicos || [];
    const frutas = datos.frutas || [];
    const maquinas = datos.maquinas || [];

    // Leer valores iniciales desde sessionStorage
    const getStoredValue = (key, defaultValue = null) => {
        const stored = sessionStorage.getItem(key);
        return stored ? JSON.parse(stored) : defaultValue;
    };

    const [selectedNumero, setNumero] = useState(getStoredValue('numero', ''));
    const [selectedFechaDesde, setFechaDesde] = useState(getStoredValue('fechaDesde', ''));
    const [selectedFechaHasta, setFechaHasta] = useState(getStoredValue('fechaHasta', ''));
    const [selectedTecnico, setSelectedTecnico] = useState(getStoredValue('tecnico'));
    const [selectedCliente, setSelectedCliente] = useState(getStoredValue('cliente'));
    const [selectedEstado, setSelectedEstado] = useState(getStoredValue('estado'));
    const [selectedFruta, setSelectedFruta] = useState(getStoredValue('fruta'));
    const [selectedMaquina, setSelectedMaquina] = useState(getStoredValue('maquina'));

    // Guardar automáticamente en sessionStorage cuando cambia algo
    useEffect(() => {
        sessionStorage.setItem('numero', JSON.stringify(selectedNumero));
    }, [selectedNumero]);

    useEffect(() => {
        sessionStorage.setItem('fechaDesde', JSON.stringify(selectedFechaDesde));
    }, [selectedFechaDesde]);

    useEffect(() => {
        sessionStorage.setItem('fechaHasta', JSON.stringify(selectedFechaHasta));
    }, [selectedFechaHasta]);

    useEffect(() => {
        sessionStorage.setItem('tecnico', JSON.stringify(selectedTecnico));
    }, [selectedTecnico]);

    useEffect(() => {
        sessionStorage.setItem('cliente', JSON.stringify(selectedCliente));
    }, [selectedCliente]);

    useEffect(() => {
        sessionStorage.setItem('estado', JSON.stringify(selectedEstado));
    }, [selectedEstado]);

    useEffect(() => {
        sessionStorage.setItem('fruta', JSON.stringify(selectedFruta));
    }, [selectedFruta]);

    useEffect(() => {
        sessionStorage.setItem('maquina', JSON.stringify(selectedMaquina));
    }, [selectedMaquina]);

    const handleSearch = () => {
        onSearch({
            numero: selectedNumero,
            fechaDesde: selectedFechaDesde,
            fechaHasta: selectedFechaHasta,
            cliente: selectedCliente,
            tecnico: selectedTecnico,
            estado: selectedEstado,
            fruta: selectedFruta,
            maquina: selectedMaquina,
        });
    };

    const handleCancel = () => {
        toggleModal();
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
                <TextField
                    label="Numero"
                    type="number"
                    variant="outlined"
                    fullWidth
                    value={selectedNumero}
                    onChange={(e) => setNumero(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField
                    label="Fecha Desde"
                    type="date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={selectedFechaDesde}
                    onChange={(e) => setFechaDesde(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <TextField
                    label="Fecha Hasta"
                    type="date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={selectedFechaHasta}
                    onChange={(e) => setFechaHasta(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                    options={tecnicos}
                    value={selectedTecnico}
                    onChange={(event, newValue) => setSelectedTecnico(newValue)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Tecnico" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                    options={clientes}
                    value={selectedCliente}
                    onChange={(event, newValue) => setSelectedCliente(newValue)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                    options={estados}
                    value={selectedEstado}
                    onChange={(event, newValue) => setSelectedEstado(newValue)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Estado" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                    options={frutas}
                    value={selectedFruta}
                    onChange={(event, newValue) => setSelectedFruta(newValue)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Fruta" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                    options={maquinas}
                    value={selectedMaquina}
                    onChange={(event, newValue) => setSelectedMaquina(newValue)}
                    getOptionLabel={(option) => option?.name || ''}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Máquina" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                
                <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                        setNumero('');
                        setFechaDesde('');
                        setFechaHasta('');
                        setSelectedTecnico(null);
                        setSelectedCliente(null);
                        setSelectedEstado(null);
                        setSelectedFruta(null);
                        setSelectedMaquina(null);

                        sessionStorage.removeItem('numero');
                        sessionStorage.removeItem('fechaDesde');
                        sessionStorage.removeItem('fechaHasta');
                        sessionStorage.removeItem('tecnico');
                        sessionStorage.removeItem('cliente');
                        sessionStorage.removeItem('estado');
                        sessionStorage.removeItem('fruta');
                        sessionStorage.removeItem('maquina');
                    }}
                    startIcon={<RestartAltIcon />}
                >
                    Limpiar
                </Button>
                <Button variant="contained" color="error" onClick={handleCancel} startIcon={<CancelIcon />}>
                    Cancelar
                </Button>
                <Button variant="contained" color="primary" onClick={handleSearch} startIcon={<SearchIcon />}>
                    Buscar
                </Button>
                
            </Grid>

        </Grid>
    );
};

export default SearchForm;
